/**
 * DONATION TYPES
 * 
 * This file contains all TypeScript types for the Donation feature.
 * 
 * @module Donations/Types
 */

// ============================================
// ENUMS
// ============================================

export enum DonationCurrency {
    ZMW = 'ZMW',
    USD = 'USD',
    EUR = 'EUR',
    GBP = 'GBP',
    CAD = 'CAD',
    AUD = 'AUD',
    ZAR = 'ZAR'
}

export enum DonationMethod {
    MOBILE_MONEY = 'mobile_money',
    BANK_TRANSFER = 'bank_transfer',
    CREDIT_CARD = 'credit_card',
    PAYPAL = 'paypal',
    STRIPE = 'stripe',
    CRYPTO = 'crypto'
}

export enum MobileMoneyProvider {
    AIRTEL = 'airtel',
    MTN = 'mtn',
    ZEDMOBILE = 'zedmobile',
    ZAMTEL = 'zamtel'
}

export enum DonationCategory {
    RADIO_PROGRAMS = 'radio_programs',
    RESEARCH = 'research',
    GOVERNANCE = 'governance',
    EDUCATION = 'education',
    HEALTH = 'health',
    EMERGENCY = 'emergency',
    GENERAL = 'general'
}

export enum DonationStatus {
    PENDING = 'pending',
    COMPLETED = 'completed',
    FAILED = 'failed',
    REFUNDED = 'refunded'
}

// ============================================
// INTERFACES
// ============================================

export interface Donation {
    _id?: string;
    donorName: string;
    donorEmail: string;
    donorPhone?: string;
    amount: number;
    currency: DonationCurrency;
    method: DonationMethod;
    mobileProvider?: MobileMoneyProvider;
    mobileNumber?: string;
    bankName?: string;
    bankAccount?: string;
    reference?: string;
    category: DonationCategory;
    message?: string;
    isAnonymous: boolean;
    isRecurring: boolean;
    frequency?: 'monthly' | 'quarterly' | 'annual';
    status: DonationStatus;
    transactionId?: string;
    createdAt: Date;
    updatedAt: Date;
    receiptSent: boolean;
    matchedDonor?: string;
    allocation: DonationAllocation;
}

export interface DonationAllocation {
    radioPrograms: number;
    research: number;
    governance: number;
    education: number;
    health: number;
    emergency: number;
    general: number;
}

export interface CreateDonationDTO {
    donorName: string;
    donorEmail: string;
    donorPhone?: string;
    amount: number;
    currency: DonationCurrency;
    method: DonationMethod;
    mobileProvider?: MobileMoneyProvider;
    mobileNumber?: string;
    bankName?: string;
    bankAccount?: string;
    reference?: string;
    category: DonationCategory;
    message?: string;
    isAnonymous: boolean;
    isRecurring: boolean;
    frequency?: 'monthly' | 'quarterly' | 'annual';
    allocation: DonationAllocation;
}

export interface DonationStats {
    totalDonations: number;
    totalAmount: number;
    averageAmount: number;
    byCategory: Record<DonationCategory, number>;
    byMethod: Record<DonationMethod, number>;
    byStatus: Record<DonationStatus, number>;
    monthlyTrends: Array<{ month: string; amount: number; count: number }>;
}
